import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleEyesYeux6 = customSolarIconWrapper(<g transform="translate(88 112.5)">
	<circle cx="50.3" cy="13" r="8.5" stroke="#202020" strokeWidth="9" strokeLinecap="round" />
	<circle cx="13" cy="17.1" r="8.5" stroke="#202020" strokeWidth="9" strokeLinecap="round" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleEyesYeux6;
